import { render, staticRenderFns } from "./BuildingQuotesPage.vue?vue&type=template&id=1d329854&scoped=true&"
import script from "./BuildingQuotesPage.vue?vue&type=script&lang=js&"
export * from "./BuildingQuotesPage.vue?vue&type=script&lang=js&"
import style0 from "./BuildingQuotesPage.vue?vue&type=style&index=0&id=1d329854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d329854",
  null
  
)

export default component.exports